import SettingsSection from './components/SettingsSection'

export function renderSecondaryNavChamberAgentSection(section, ctx) {
  const key = `${section.type}-${ctx.index}`

  if (section.type === 'settingsList') {
    return <SettingsSection key={key} />
  }

  return null
}
